<template>
  <section id="shop">
    <h2>SHOP</h2>
    <div class="merch-wrapper">
      <a class="merch-item" href="https://www.indiegogo.com/projects/american-holocaust-the-movie">
        <img src="../assets/merch/instafame.png" />
        <div class="merch-details">
          <p>InstaFame Hoodie</p>
          <p>$135 USD</p>
        </div>
      </a>
      <a class="merch-item" href="https://www.indiegogo.com/projects/american-holocaust-the-movie">
        <img src="../assets/merch/ANTISUPREMACYHOODIE.png" />
        <div class="merch-details">
          <p>F*ck Supremacy Hoodie</p>
          <p>$150 USD</p>
        </div>
      </a>
      <a class="merch-item" href="https://www.indiegogo.com/projects/american-holocaust-the-movie">
        <img src="../assets/merch/FAKENEWSCAP.png" />
        <div class="merch-details">
          <p>Fake News Hoodie</p>
          <p>$175 USD</p>
        </div>
      </a>
      <a class="merch-item" href="https://www.indiegogo.com/projects/american-holocaust-the-movie">
        <img src="../assets/merch/NADA-HOODIE.png" />
        <div class="merch-details">
          <p>Nada Hoodie</p>
          <p>$120 USD</p>
        </div>
      </a>
    </div>
  </section> 
</template>

<style scoped lang="scss">
#shop {
  background: {
    image: url('../assets/SMILEYSOLO.png');
    size: 50%;
    repeat: space;
  }
}

.merch-wrapper {
  display: grid;
  grid-template-columns: 1fr;
  gap: 30px;

  .merch-item {
    border: 1px solid grey;
    width: 230px;
    margin: auto;
    background: whitesmoke;
    border-radius: 5px;
    color: black;

    &:hover {
      cursor: pointer;
      transition: all .3s cubic-bezier(.16,.8,.45,1);
      box-shadow: 0 2px 6px -4px rgba(0,0,0,.2), 0 8px 10px -4px rgba(0,0,0,.14), 0 8px 12px 4px rgba(0,0,0,.05);
    }

    .merch-details {
      background: white;
      padding: 16px 12px;
    }

    p {
      font-size: 20px;
      text-align: left;

      &:last-of-type {
        margin-top: 12px;
      }
    }
  }
}

img {
  width: 70%;
  justify-self: center;
}

@media screen and (min-width: 768px) {
  #shop {
    background: {
      size: 33%;
      repeat: round;
    }
  }

  .merch-wrapper {
    grid-template-columns: 1fr 1fr;
    align-items: center;
    max-width: 90%;
    margin: auto;
    gap: 64px 100px;
  }

  img {
    width: 75%; 

    &:nth-child(odd) {
      justify-self: right;
    }
    
    &:nth-child(even) {
      justify-self: left;
    }
  }
}

@media screen and (min-width: 1280px) {
  #shop {
    background: {
      size: 58px;
    }
  }
  
  .merch-wrapper {
    grid-template-columns: repeat(3,1fr);

    .merch-item {
      width: 300px;
    }
  }

  img {
    &:nth-child(odd),
    &:nth-child(even) {
      justify-self: center;
    }
  }
}
</style>